import { render, staticRenderFns } from "./SmsPay.vue?vue&type=template&id=8cb8cc0a"
import script from "./SmsPay.vue?vue&type=script&lang=js"
export * from "./SmsPay.vue?vue&type=script&lang=js"
import style0 from "./SmsPay.vue?vue&type=style&index=0&id=8cb8cc0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports